export default __webpack_public_path__ + "static/media/logo_reservations.914fbce9.svg";